<template>
    <DCard
        padding
    >
        <DFormRow
            :label="__('settings.hosting_notification_settings.min_quota_for_mail')"
            is-required
            :error="errors.min_quota_for_mail"
            :hint="__('settings.hosting_notification_settings.min_quota_for_mail_hint')"
        >
            <DInput
                id="min_quota_for_mail"
                v-model="min_quota_for_mail"
                :is-valid="min_quota_for_mail > 0"
            />
        </DFormRow>
        <DFormControls
            @submit="saveSettings"
        />
    </DCard>
</template>

<script>

export default {
    name: 'Create',
    props: {
        errors: {
            type: Object,
            default () { return {} }
        },
        setting: {
            type: Object,
            default () { return {} }
        }
    },
    data () {
        return {
            min_quota_for_mail: this.setting.min_quota_for_mail ?? null
        }
    },
    methods: {
        saveSettings () {
            this.$inertia.post(this.$route('settings.hosting-notification-settings.store'), {
                min_quota_for_mail: this.min_quota_for_mail
            })
        }
    }
}
</script>

<style scoped>

</style>
